import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { RECORD_DELETED_SUCCESSFULLY } from 'components/common/FSBToastify/types';
import { DELETE_CATEGORY } from 'pages/Products/ProductsGraphQL';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import FSBModal from 'components/common/FSBModal';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import { Col, Row } from 'reactstrap';
import DebounceTextInput from 'components/DebounseTextInput';
import ProductTable from './components/ProductTable';
import AddEditProduct from './components/AddEditProduct';
import './ProductTab.css';

const ProductTab = () => {
  const [showAddRecord, setAddRecord] = useState({
    status: false,
    row: '',
    type: ADD_EDIT_CONSTANT.ADD,
  });

  const [deleteRowId, setDeleteRowId] = useState('');
  const [showDeleteRecord, setDeleteRecord] = useState(false);

  const [searchString, setSearchString] = useState('');

  const handleChange = (value) => {
    setSearchString(value);
  };

  const [deleteCategory] = useMutation(DELETE_CATEGORY, {
    // eslint-disable-next-line no-shadow
    onCompleted: () => {
      toast.success(RECORD_DELETED_SUCCESSFULLY);
      setDeleteRowId('');
      setDeleteRecord(!showDeleteRecord);
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ message }) => {
        return message;
      });
    },
  });

  const toggleDeleteRecord = (id) => {
    setDeleteRecord(!showDeleteRecord);
    setDeleteRowId(id);
  };

  const onDeleteConfirmation = async () => {
    try {
      await deleteCategory({
        variables: { id: deleteRowId },
      });
    } catch (err) {
      toast.error(err);
    }
  };

  const toggleAddRecord = (row, type) => {
    setAddRecord({ status: !showAddRecord.status, row, type });
  };
  const handleClickEdit = (val, type) => {
    toggleAddRecord(val, type);
  };
  return (
    <div className="product-page">
      <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />

      <FSBModal
        title={`${
          showAddRecord.type === ADD_EDIT_CONSTANT.EDIT
            ? showAddRecord.type
            : ADD_EDIT_CONSTANT.ADD
        } Product`}
        closeButtonLabel=""
        confirmButtonLabel=""
        open={showAddRecord.status}
        toggleAlert={toggleAddRecord}
        onClose={toggleAddRecord}
        message=""
        modalClass="right-drawer"
      >
        <AddEditProduct
          toggleAddRecord={toggleAddRecord}
          currentRow={showAddRecord.row}
          type={showAddRecord.type}
        />
      </FSBModal>

      <div className="products-toolbar">
        <Row>
          <Col sm={6} className="text-end">
            <DebounceTextInput
              onInputChange={handleChange}
              delay={500} // Set your desired delay in milliseconds
              value={searchString}
              placeholder="Search by product"
              positionTop="-52px"
              positionRight="95px"
              classWrapper="product-search products-search"
            />
          </Col>
        </Row>
        <ProductTable
          searchString={searchString}
          handleClickEdit={handleClickEdit}
          toggleDeleteRecord={toggleDeleteRecord}
          toggleAddRecord={toggleAddRecord}
        />
      </div>
    </div>
  );
};

export default ProductTab;
